import { useEffect, useState } from 'react';
import { accountRef, subscribeDoc } from '@/lib/firestore';
import type { Account } from '@/schemas';

export type AccountWithId = Account & { id: string };

export function useAccount(aid: string | null): {
  account: AccountWithId | null;
  loading: boolean;
} {
  // Derived loading: see useMyMemberships for the why.
  const [state, setState] = useState<{ loadedAid: string | null; data: AccountWithId | null }>({
    loadedAid: null,
    data: null,
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: null });
      return;
    }
    setState({ loadedAid: null, data: null });
    const unsub = subscribeDoc<Account>(accountRef(aid), (data) => {
      setState({ loadedAid: aid, data: data as AccountWithId | null });
    });
    return unsub;
  }, [aid]);
  return {
    account: state.loadedAid === aid ? state.data : null,
    loading: aid != null && state.loadedAid !== aid,
  };
}
